import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "react-router-dom";
import PrivateRoute from "@/components/route-helper/PrivateRoute";
import UsersTab from "./subpages/Users";
import RolesMainPage from "./subpages/Roles/MainPage";
import RolesCreationPage from "./subpages/Roles/CreationPage";
import RolesEditingPage from "./subpages/Roles/EditingPage";
import DetailsTab from "./subpages/Details";
import AddressTab from "./subpages/Adresses";
import BaseRecordRenderer from "@reusables/BaseRecordRenderer";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { useGetCompanyQuery } from "@redux/features/companies/companiesApi";
import EmployeesTab from "./subpages/Employees/EmployeesTab";
import BaseTabs from "@reusables/BaseTabs";
import { setCompany } from "@redux/features/auth/authSlice";
import { toastError } from "@helpers/utils";

export default function CompanyInformationPage() {
    const { t } = useTranslation("", { keyPrefix: "settings.general.companyInformation.tabs" });

    const selectedCompany = useAppSelector(state => state.auth.user?.company);

    const dispatch = useAppDispatch();

    /**
     This query and subsequent useEffect are used to update the company data in the store and then use it in the rest of the page
     */
    const {
        data: freshCompanyData,
        isLoading: isSelectedCompanyLoading,
        isError,
        error
    } = useGetCompanyQuery(selectedCompany!.id, {
        refetchOnMountOrArgChange: true,
        skip: !selectedCompany
    });

    useEffect(() => {
        if (freshCompanyData) {
            dispatch(setCompany(freshCompanyData));
        }
    }, [freshCompanyData, dispatch]);

    // Handle error state (e.g., show toast)
    useEffect(() => {
        if (isError && error) {
            toastError(error);
        }
    }, [isError, error]);


    return (
        <div className="levitation-extended w-full">
                <BaseRecordRenderer
                    loading={isSelectedCompanyLoading}
                    dontShowNotFound
                    hideLevitation
                >
                    <BaseTabs
                        tabs={[
                            {
                                key: "details",
                                title: t("companyDetails.title"),
                            },
                            {
                                key: "address",
                                title: t("address.title"),
                            },
                            {
                                key: "employees",
                                title: t("employees.title"),
                            },
                            {
                                key: "users",
                                title: t("users.title"),
                            },
                            {
                                key: "roles",
                                title: t("roles.title"),
                            }
                        ]}
                    />
                    <Switch>
                        <PrivateRoute
                            path="/dashboard/settings/company/details"
                            component={() => <DetailsTab />}
                            exact
                        />

                        <PrivateRoute
                            path="/dashboard/settings/company/address"
                            component={() => <AddressTab />}
                            exact
                        />

                        <PrivateRoute
                            path="/dashboard/settings/company/employees"
                            component={() => <EmployeesTab />}
                            exact
                        />

                        <PrivateRoute
                            path={`/dashboard/settings/company/users`}
                            component={() => <UsersTab />}
                            exact
                        />

                        <PrivateRoute
                            path="/dashboard/settings/company/roles"
                            component={() => <RolesMainPage />}
                            exact
                        />

                        <PrivateRoute
                            path="/dashboard/settings/company/roles/new"
                            component={() => <RolesCreationPage />}
                            exact
                        />

                        <PrivateRoute
                            path="/dashboard/settings/company/roles/:id"
                            component={() => <RolesEditingPage />}
                            exact
                        />
                    </Switch>
                </BaseRecordRenderer>
        </div>
    );
}